export const CALENDAR = 'calendar';
export const ALBUMS = 'albums';
export const INTERACTIVE_IMPORT = 'interactiveImport.albums';
export const WANTED_CUTOFF_UNMET = 'wanted.cutoffUnmet';
export const WANTED_MISSING = 'wanted.missing';

export default {
  CALENDAR,
  ALBUMS,
  INTERACTIVE_IMPORT,
  WANTED_CUTOFF_UNMET,
  WANTED_MISSING
};
